import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '~/contexts/AuthContext';

// Two-step gate, matching the edge function's behavior:
//   1. No user at all          → /login
//   2. User signed in at AAL1  → /mfa  (enroll if no factor; challenge if has)
//   3. User signed in at AAL2  → render the protected route
//
// The edge gate is the actual security boundary (it blocks the chunk over
// the wire). This client-side guard is defense in depth + the right UX
// signal during the brief window before the edge fires for SPA navigations.
export default function RequireAuth() {
  const { user, loading, currentAAL } = useAuth();
  const location = useLocation();

  if (loading) return <div className="p-6">Loading…</div>;

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (currentAAL !== 'aal2') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/mfa?next=${next}`} replace />;
  }

  return <Outlet />;
}
